module.exports = __webpack_public_path__ + "img/ic_tcloud2.d02cff8b.svg";